import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BuildingsComponent } from 'src/app/modules/buildings/buildings.component';
import { DefaultComponent } from './layouts/default/default.component';
import { BuildingPreviewComponent } from './modules/building-preview/building-preview.component';
import { BuildingsMapComponent } from './modules/buildings-map/buildings-map.component';
import { DashboardComponent } from './modules/dashboard/dashboard.component';
import { ManagementComponent } from './modules/management/management.component';
import { MunicipalitiesComponent } from './modules/municipalities/municipalities.component';
import { PeriodsComponent } from './modules/periods/periods.component';
import { AuthGuardService } from './shared/services/auth-guard.service';

const routes: Routes = [
  {
    path: '',
    component: DefaultComponent,
    children: [
      {
        path: '',
        component: BuildingsMapComponent,
      },
      {
        path: 'buildings',
        component: BuildingsComponent,
        canActivate: [AuthGuardService],
      },
      {
        path: 'periods',
        component: PeriodsComponent,
        canActivate: [AuthGuardService],
      },
      {
        path: 'buildings-map',
        component: BuildingsMapComponent,
      },
      {
        path: 'management',
        component: ManagementComponent,
        canActivate: [AuthGuardService],
      },
      {
        path: 'municipalities',
        component: MunicipalitiesComponent,
        canActivate: [AuthGuardService],
      },
      {
        path: 'dashboard',
        component: DashboardComponent,
        canActivate: [AuthGuardService],
      },
      {
        path: 'building/:id/preview',
        component: BuildingPreviewComponent,
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
